<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/35lWb3/tc-custom/9781423623168.jpg?1720805320812" alt="This image is the cover for the book Mastering the Art of Southern Cooking"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mastering the Art of Southern Cooking
      </h1>
      <p class="bookDescription body article font2">
        <p><b>This definitive guide to Southern cooking methods and techniques by the creators of the PBS show <i>New Southern Cooking</i> features more than 600 recipes<i>.</i></b><br/>  <br/> In <i>Mastering the Art of Southern Cooking</i>, Nathalie Dupree and Cynthia Graubart present the most comprehensive book on Southern cuisine in nearly a century. Based on years of research, Dupree and Graubart embrace the great Southern cookbooks and recipes of the past, enhancing them with the foods and conveniences of today.<br/>  <br/> With more than 600 recipes and hundreds of step-by-step photographs, Dupree and Graubart make it easy to learn the techniques for creating the South’s fabulous cuisine. From basics such as cleaning vegetables and scrubbing a country ham, to show-off skills like making a soufflé and turning out the perfect biscuit—all are explained and pictured with clarity and plenty of stories that entertain.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nathalie Dupree, Cynthia Graubart, Pat Conroy
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gibbs Smith
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5c275cd4